export class CrossVisibilityFieldConfigModel {
  field: fieldNameModel[];
}

export class fieldNameModel {
  visibleFields: Array<string>;
  hiddenFields: Array<string>;
}
